module.exports = __webpack_public_path__ + "static/media/Kissen_60x30_rueckseite.26556759.png";